import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {gsApi} from "../auth/auth";
import { currentAnnouncementsURL, getThunkResponse, usersURL } from "../app/api";
import { GSItemInfo } from "golfstatus_react_components";
import {
  faFileInvoiceDollar,
} from "@fortawesome/free-solid-svg-icons";
import { getTournament } from "./tournamentSlice";

export const selectUser = createAsyncThunk(
  "app/selectUser",
  async (userID, thunkAPI) => {
    let url = `${usersURL}/${userID}`;
    const response = await gsApi.get(url, {
      data: {
        include: "organization-users,tournament-users",
      },
    });
    return response;
  }
);

export const getCurrentAnnouncements = createAsyncThunk(
  "app/getCurrentAnnouncements",
  async (thunkAPI) => {
    const response = await gsApi.get(`${currentAnnouncementsURL}`);
    return response;
  }
)

export const appSlice = createSlice({
  name: "app",
  initialState: {
    title: "Tournament Management",
    theme: "light",
    announcements: [],
    loggedInUser: {},
    nav: [],
    notifications: [],
    loading: [],
    history: [],
  },
  reducers: {
    setNav: (state, action) => {
      state.nav = action.payload;
    },
    setTheme: (state, action) => {
      state.theme = action.payload;
    },
    setNotifications: (state, action) => {
      state.notifications = action.payload;
    },
    addNotification: (state, action) => {
      state.notifications.unshift(action.payload);
    },
    removeNotification: (state, action) => {
      const newNotifications = state.notifications.filter(
        (not) => not.id !== action.payload.id
      );
      state.notifications = newNotifications;
    },
    clearNotifications: (state, action) => {
      state.notifications = [];
    },
    setHistory: (state, action) => {
      state.history = action.payload;
    },
    addPathToHistory: (state, action) => {
      state.history.unshift(action.payload);
    },
  },
  extraReducers: {
    [selectUser.fulfilled]: (state, action) => {
      state.loggedInUser = action.payload;
    },
    ...getThunkResponse(getCurrentAnnouncements, (state, action) => {
      state.announcements = action.payload;
    }),
    ...getThunkResponse(getTournament, (state, action) => {
      const tournament = action.payload;

      if (state.currentTournament?.id !== tournament?.id || state.currentTournament?.invoicingBannerActive !== tournament?.invoicingBannerActive) {
        state.currentTournament = tournament;
        if (tournament?.invoicingBannerActive) {
          const notification = {
            id: tournament.id,
            header: (
              <GSItemInfo
                header={
                  "Event Site Invoice Payment Option Enabled—Just One More Step"
                }
                value={
                  "Before registrants can select this option at checkout, you’ll need to provide the required organization information."
                }
                icon={faFileInvoiceDollar}
              />
            ),
            state: "success",
            tournament: tournament,
            type: "invoice",
          };
          state.notifications = [
            ...state.notifications.filter?.((n) => n?.type !== "invoice"),
            notification,
          ];
        }
      }
    }),
  },
});

export const {
  setNav,
  setTheme,
  addNotification,
  setNotifications,
  clearNotifications,
  setHistory,
  addPathToHistory,
  removeNotification,
} = appSlice.actions;

export const selectNav = (state) => state.app.nav;
export const selectTitle = (state) => state.app.title;
export const selectAppNotifications = (state) => state.app.notifications;
export const selectTheme = (state) => state.app.theme;
export const selectLoggedInUser = (state) => state.app.loggedInUser;
export const selectHistory = (state) => state.app.history;
export const selectAnnouncements = (state) => state.app.announcements;

export default appSlice.reducer;
